<div class="customize-fields__inner-container">
  <field-type-number [field]="customizeFieldFormula.decimalsInfo"
    [preSelectItem]="customizeFieldFormula.field.decimals"
    [decimals]="0"
    (itemSelected)="itemSelected($event, 'decimals')">
  </field-type-number>
  <!-- Configuración de la fórmula -->
  <div class="common-text-input__container"
    [id]="field.id">
    <div class="common-field-with-button__container-box"
      [ngClass]="{'common-field-with-button__container-box--error': customizeFieldFormula.configurationFieldForm.error}"
      [attr.disabled]="previewMode || customizeFieldFormula.configurationFieldForm.noEditable?true:null">
      <div class="common-field-with-button__block-header">
        <label class="common-text-input__label-no-cursor">
          <span class="common-text-input__text-label">{{customizeFieldFormula.configurationFieldForm.label}}</span>
          <span class="common-tag__mandatory-text-asterisk">*</span>
        </label>
        <div class="common-field-with-button__text-description"
          [innerHTML]="customizeFieldFormula.configurationFieldForm.description"></div>
      </div>
      <div class="common-field-with-button__buttons-container">
        <button class="common-button__text-little-border"
          [disabled]="previewMode"
          (click)="launchFormulaSettings()">
          <i class="lf-icon-configuration common-icon__sm"></i>
          <span class="common-button__text-little-title"
            [afTranslate]="'anti-money-laundering-onboarding.configure'">_Configurar</span>
        </button>
      </div>
      @if(customizeFieldFormula.formulaItems?.length){
        <div class="common-field-with-button__items-block">
          <div class="common-field-with-button__item-container-list-fine"
            [attr.disabled]="previewMode || customizeFieldFormula.field.noEditable?true:null">
            <div class="common-field-with-button__text-column-container">
              <div class="common-field-with-button__info-line-container">
                <span class="common-field-with-button__label-text">
                  <span [afTranslate]="'customize.result'">Resultado</span>:
                </span>
              </div>
              <div class="customize-field-formula__container-result-text">
                @for (item of customizeFieldFormula.formulaItems; track $index) {
                  <span>{{item.text}}</span>
                }
              </div>
            </div>
            @if(!previewMode && !customizeFieldFormula.field.noEditable){
              <button class="common-field-with-button__button-action"
                (click)="resetResultConfigurated()">
                <i class="lf-icon-trash common-icon__md"></i>
              </button>
            }
          </div>
        </div>
      }
    </div>
    @if(customizeFieldFormula.configurationFieldForm.error){
      <div class="common-text-input__mandatory-tag">
        <span [afTranslate]="customizeFieldFormula.formulaFieldsDeleted?'customize-field-formula.formula-error-field-deleted':'common.field-mandatory'">Campo obligatorio</span>
      </div>
    }
  </div>
  <div class="customize-fields-switch-form__container">
    <field-type-switch
      [field]="{label: 'customize.code-color'| afTranslate}"
      [small]="true"
      [preSelectItem]="customizeFieldFormula.field.codeColor"
      [disabled]="previewMode"
      (itemSelected)="changeOptionOn($event, 'codeColor')">
    </field-type-switch>
  </div>
  @if (customizeFieldFormula.field.codeColor) {
    <div class="common-text-input__container">
      <div class="common-text-input__container-box-configure-custom"
        [ngClass]="{'common-text-input__container-box-configure-custom--error': customizeFieldFormula.encondingError || customizeFieldFormula.encondingSaveError}"
        [attr.disabled]="previewMode || customizeFieldFormula.field.noEditable?true:null">
        <div  class="common-text-input__container-header-info">
          <div class="common-text-input__block-header">
            <div class="common-text-input__label-no-cursor">
              <span class="common-text-input__text-label"
                [afTranslate]="'customize-field-formula.encoding-group'">Valores de codificación</span>
              <span class="common-tag__mandatory-text-asterisk">*</span>
            </div>
          </div>
          <div class="common-text-input__info-header"
              [afTranslate]="'customize-field-formula.encoding-help'">_Define el mensaje y color que se mostrará al usuario en función de los valores obtenidos en la fórmula. Edita los siguientes campos y continua añadiendo tantos rangos de valor como necesites.</div>
        </div>
        <div class="customize-field-list__container-list-values"
          cdkDropList
          [cdkDropListData]="customizeFieldFormula.field.fieldEncodings"
          (cdkDropListDropped)="reorderContainer($event)">
          @for(encodingItem of customizeFieldFormula.field.fieldEncodings; track $index){
            @if (encodingItem.showConfigurationEncoding) {
              <customize-codification-values
                [field]="customizeFieldFormula.field"
                [item]="encodingItem"
                [typeView]="'edit'"
                (changeEncodingValue)="closeEncodingValue($event, 'edit')"></customize-codification-values>
            }@else{
              <div class="customize-field-list__container-elements-value"
                cdkDrag>
                <div class="customize-field-list__element-value-list"
                  [attr.disabled]="customizeFieldFormula.showConfigurationEncoding || customizeFieldFormula.showItemConfigurationEncoding || previewMode?true:null">
                  <button class="common-button__icon-md-drag-handle"
                    cdkDragHandle
                    [disabled]="customizeFieldFormula.showConfigurationEncoding || customizeFieldFormula.showItemConfigurationEncoding || previewMode"
                    [cdkDragHandleDisabled]="customizeFieldFormula.showConfigurationEncoding || customizeFieldFormula.showItemConfigurationEncoding || previewMode">
                    <i class="lf-icon-arrow-up-down common-icon__md"></i>
                  </button>
                  <div class="customize-field-list__items-element-value">
                    <div class="customize-field-list__items-element-value-inner">
                      <div class="common-text-input__field-container">
                        <label class="common-text-input__block-field-input"
                          [attr.disabled]="true">
                          <input class="common-text-input__input"
                            type="text"
                            autocomplete="off"
                            [placeholder]="'customize-field.add-value' | afTranslate"
                            [(ngModel)]="encodingItem.displayText"
                            [disabled]="true"/>
                        </label>
                      </div>
                      <div>
                        <div class="common-dropdown-list__button-colors"
                          [attr.disabled]="true">
                          <i [class]="'lf-icon-step-final common-icon__md-code-color-' + (encodingItem.color | colors:'highlightListColors')"></i>
                        </div>
                      </div>
                      <div class="customize-field-list__actions-element-value">
                        @if (!customizeFieldFormula.field.noEditable && !customizeFieldFormula.showConfigurationEncoding && !previewMode) {
                          <button class="customize-field-list__button-md-trash"
                            (click)="editEncodingItem(encodingItem)">
                            <i class="lf-icon-editable-form common-icon__md"></i>
                          </button>
                          <button class="customize-field-list__button-md-trash"
                            (click)="deleteEncodingItem(encodingItem)">
                            <i class="lf-icon-trash common-icon__md"></i>
                          </button>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          }
        </div>
        @if (customizeFieldFormula.showConfigurationEncoding) {
          <customize-codification-values
            [field]="customizeFieldFormula.field"
            [typeView]="'new'"
            (changeEncodingValue)="closeEncodingValue($event, 'new')"></customize-codification-values>
        }
        <div>
          <button class="common-button__icon-md-border"
            [pTooltip]="'customize-field.new-value' | afTranslate"
            tooltipPosition="top"
            [tooltipDisabled]="customizeFieldFormula.showConfigurationEncoding || customizeFieldFormula.showItemConfigurationEncoding || previewMode"
            (click)="openNewEncoding()"
            [disabled]="customizeFieldFormula.showConfigurationEncoding || customizeFieldFormula.showItemConfigurationEncoding || previewMode">
            <i class="lf-icon-sum common-icon__md"></i>
          </button>
        </div>
      </div>
      @if(customizeFieldFormula.encondingError || customizeFieldFormula.encondingSaveError){
        <div class="common-text-input__mandatory-tag">
          <span [afTranslate]="customizeFieldFormula.encondingSaveError?'common.field-mandatory':'customize-field.error-configuration'">_Campo obligatorio</span>
        </div>
      }
    </div>
  }
  <div class="customize-fields-switch-form__container">
    <customize-fields-switch-form
      [field]="customizeFieldFormula.field"
      [small]="true"
      [concept]="concept"
      [isPrivate]="isPrivate"
      [hiddenInLandings]="hiddenInLandings"
      [previewMode]="previewMode"></customize-fields-switch-form>
    <field-type-switch
      [field]="{label: 'customize-field-formula.always-hide'| afTranslate}"
      [small]="true"
      [preSelectItem]="customizeFieldFormula.field.hidden"
      [disabled]="previewMode"
      (itemSelected)="changeOptionOn($event, 'hidden')">
    </field-type-switch>
    <field-type-switch
      [field]="{label: 'customize-field-formula.null-as-zero'| afTranslate}"
      [small]="true"
      [preSelectItem]="customizeFieldFormula.field.nullsAsZero"
      [disabled]="previewMode"
      (itemSelected)="changeOptionOn($event, 'nullsAsZero')">
    </field-type-switch>
  </div>
</div>
